import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo, metaTags } from '../config/seoConfig.mjs';

function setHeadTag(selector, tagName, attributes, text) {
  const [existing, ...duplicates] = document.head.querySelectorAll(selector);
  duplicates.forEach((node) => node.remove());
  if (!attributes) {
    existing?.remove();
    return;
  }
  const node = existing || document.createElement(tagName);
  Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
  if (text !== undefined) node.textContent = text;
  if (!existing) document.head.appendChild(node);
}

export default function SeoManager() {
  const { pathname } = useLocation();
  // Update before passive analytics effects read document.title. One owner means
  // page unmounts cannot restore old metadata over the newly selected route.
  useLayoutEffect(() => {
    const seo = resolveSeo(pathname);
    document.title = seo.title;
    metaTags(seo).forEach(([attribute, key, value]) => {
      setHeadTag(`meta[${attribute}="${key}"]`, 'meta',
        value == null ? null : { [attribute]: key, content: value });
    });
    setHeadTag('link[rel="canonical"]', 'link',
      seo.canonical ? { rel: 'canonical', href: seo.canonical } : null);
    setHeadTag('script#seo-jsonld', 'script',
      seo.jsonLd ? { id: 'seo-jsonld', type: 'application/ld+json' } : null,
      seo.jsonLd ? JSON.stringify(seo.jsonLd) : undefined);
  }, [pathname]);
  return null;
}
